import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 pb-52 pt-6"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-5xl" }
const _hoisted_3 = { class: "w-full mt-10" }
const _hoisted_4 = { class: "flex flex-col items-center text-center rounded-lg shadow-lg mt-4 bg-gray-200 p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, { class: "space-y-4 text-gray-700" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "font-bold text-gray-800 mb-0 text-2xl text-center pt-5" }, " ESTADO DEL PAGO ", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.errorMessage), 1)
              ])
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-8" }, null, -1))
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}